import { ApiCore } from '@/services/api/utils/core.js'

const url = 'config'
const plural = 'configs'
const single = 'config'

const api = new ApiCore({
	index: true,
	url: url,
	plural: plural,
	single: single
})

export default api
